// store/slices/paymentSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export type PaymentMode = 'cluster' | 'link' | 'notification'

interface PaymentState {
  isOpen: boolean
  clusterId: number | null
  mode: PaymentMode | null
}

const initialState: PaymentState = {
  isOpen: false,
  clusterId: null,
  mode: null,
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    openPayment: (state, action: PayloadAction<{ clusterId: number; mode?: PaymentMode }>) => {
      state.isOpen = true
      state.clusterId = action.payload.clusterId
      state.mode = action.payload.mode || 'cluster'
    },
    closePayment: (state) => {
      state.isOpen = false
      state.clusterId = null
      state.mode = null
    },
  },
})

export const { openPayment, closePayment } = paymentSlice.actions

export const selectPayment = (state: RootState) => state.payment
export const selectPaymentIsOpen = (state: RootState) => state.payment.isOpen
export const selectPaymentClusterId = (state: RootState) => state.payment.clusterId

export default paymentSlice.reducer
